import { useContext } from "react";
import { BankConciliationContext } from "../../contexts/bankConciliationContext";

// import { Container } from './styles';

function useBankConciliationContext() {
  const values = useContext(BankConciliationContext);
  return values;
}

export default useBankConciliationContext;
